import { cpf } from 'cpf-cnpj-validator';

export const hasAValidCPFStringFormat = (value) => /[0-9]{3}\.[0-9]{3}\.[0-9]{3}-[0-9]{2}/.test(value);

export const cpfValid = (value) => hasAValidCPFStringFormat(value) && cpf.isValid(value);

export const invalidCPF = (value) => cpfValid(value) === false;
